import CoreTag from './core';
import Tag from './basic';
import RecordTag from './record';
import FilterTag from './filter';
import StatusGoodTag from './status/good';
import StatusAverageTag from './status/average';
import StatusBadTag from './status/bad';
import PriorityHotTag from './priority/hot';
import PriorityWarmTag from './priority/warm';
import PriorityColdTag from './priority/cold';
import TagGroup from './group';
export { CoreTag, Tag, RecordTag, FilterTag, StatusGoodTag, StatusAverageTag, StatusBadTag, PriorityHotTag, PriorityWarmTag, PriorityColdTag, TagGroup };